// extracted by mini-css-extract-plugin
export default {"gridContainer":"VisitsList_gridContainer__M+tje"};